// extracted by mini-css-extract-plugin
module.exports = {"toggle":"SelectToggle_toggle__EtujD","selected":"SelectToggle_selected__CxiMg","disabled":"SelectToggle_disabled__tOWc4"};